<!--
 * @Author: shiao
 * @Date: 2020-12-28 17:18:09
 * @LastEditTime: 2021-01-28 14:14:01
 * @Description: 
 * @LastEditors: shiao
 * @FilePath: \o2o-appd:\gongsi\h5-hotel\h5\src\pages\hotel\detail\components\skeleton-hotelroom.vue
-->
<template>
  <div class="skeleton">
    <div class="one">
      <skeleton width="24.0rem" height="2.2rem" />
      <skeleton width="8.5rem" height="2.2rem" />
    </div>
    <div class="two">
      <skeleton width="6.2rem" height="3.6rem" />
      <skeleton width="6.2rem" height="3.6rem" />
      <skeleton width="6.2rem" height="3.6rem" />
      <skeleton width="6.2rem" height="3.6rem" />
    </div>
    <div class="three">
      <div class="three-one">
        <skeleton width="9.0rem" height="9.0rem" />
      </div>
      <div class="three-two">
        <skeleton width="9.0rem" height="2.2rem" />
        <div class="three-two-two">
          <skeleton width="3.0rem" height="2.0rem" />
          <skeleton width="6.2rem" height="2.0rem" />
        </div>
        <div class="three-two-three">
          <skeleton width="4.0rem" height="1.7rem" />
          <skeleton width="4.0rem" height="1.7rem" />
          <skeleton width="4.0rem" height="1.7rem" />
        </div>
      </div>
      <div class="three-three">
        <skeleton width="5.0rem" height="3.0rem" backgroundColor="#FFC3BE" />
        <skeleton width="7.8rem" height="2.0rem" backgroundColor="#FFE2D7" />
        <skeleton width="8.5rem" height="3.0rem" backgroundColor="#F5F6F7" />
      </div>
    </div>
    <div class="four" v-for="(c, i) in '12'" :key="i">
      <div class="four-one">
        <skeleton width="9.0rem" height="9.0rem" />
      </div>
      <div class="four-two">
        <skeleton width="10.3rem" height="2.2rem" />
        <skeleton width="14.0rem" height="1.7rem" />
      </div>
      <div class="four-three">
        <skeleton width="4.0rem" height="2.0rem" />
      </div>
    </div>
  </div>
</template>

<script>
import skeleton from "../../components/skeleton.vue";
export default {
  components: {
    skeleton,
  },
};
</script>
<style >
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style scoped lang='less'>
.s-box {
  display: inline-block;
}
.skeleton {
  padding: 0 1.5rem;
  .van-skeleton {
    display: inline-block;
    margin: 0rem 0 1.0rem 0;
    padding: 0;
    .van-skeleton__content {
      //   width: 50rem;
    }
    .van-skeleton__row {
      height: 2.2rem;
      border-radius: 0.5rem;
    }
  }
  .one {
    .s-box:first-child {
      margin-right: 2.0rem;
    }
    margin-bottom: 1.5rem;
  }
  .two {
    .s-box {
      margin-right: 1.0rem;
    }
    margin-bottom: 2.0rem;
  }
  .three {
    display: flex;
    font-size: 0;
    margin-bottom: 2.0rem;
    .three-one {
      flex: 1;
    }
    .three-two {
      width: 13.5rem;
      .three-two-two {
        margin-top: 0.5rem;
        .s-box:first-child {
          margin-right: 0.5rem;
        }
      }
      .three-two-three {
        margin-top: 0.5rem;
        .s-box {
          margin-right: 0.5rem;
        }
      }
    }
    .three-three {
      font-size: 0;
      text-align: right;
      width: 10.0rem;
      .s-box:nth-child(2) {
        margin-top: 0.5rem;
      }
      .s-box:nth-child(3) {
        margin-top: 0.5rem;
      }
    }
  }
  .four {
    font-size: 0;
    display: flex;
    margin-bottom: 2.0rem;
    .four-one {
      flex: 1;
      margin-right: 1.0rem;
    }
    .four-two {
      margin-top: 2.3rem;
      font-size: 0;
      .s-box:nth-child(2) {
        margin-top: 0.5rem;
      }
    }
    .four-three {
      text-align: right;
      .s-box:nth-child(1) {
        margin-top: 3.5rem;
      }
    }
  }
}
</style>